import { useEffect, useState, useMemo } from 'react';
import {
  ConsumerApi,
  DIFF_MODE_EVENT,
  READ_ONLY_EVENT,
  HISTORY_MODE_EVENT,
  SET_STATE_FROM_VERSION_EVENT
} from '@contently/editor';
import { useSelector } from 'react-redux';
import ContentProvider from '../utils/contentProvider';

export default function useTextEditor(contentId, historyMode, readyOnlyMode, format) {
  const { diffMode, activeVersionIndex, versions } = useSelector(state => state.textEditor || {});
  const [provider, setProvider] = useState(null);
  const consumerApi = useMemo(() => new ConsumerApi(), []);

  useEffect(() => {
    setProvider(new ContentProvider(contentId, '/api/v2/editor_proxy', format));
  }, [contentId, format]);

  useEffect(() => {
    if (historyMode || readyOnlyMode) {
      consumerApi.emit(READ_ONLY_EVENT, true);
      if (historyMode) {
        consumerApi.emit(HISTORY_MODE_EVENT, true);
      }
    } else {
      consumerApi.emit(READ_ONLY_EVENT, false);
      consumerApi.emit(HISTORY_MODE_EVENT, false);
    }
  }, [historyMode, readyOnlyMode, consumerApi]);

  useEffect(() => {
    async function fetchVersion() {
      const index = historyMode ? activeVersionIndex : versions.length - 1;
      const { doc, changeSet } = await provider.goToVersion(index, versions);
      if (changeSet) {
        consumerApi.emit(SET_STATE_FROM_VERSION_EVENT, { newDoc: doc, changeSet });
      }
    }
    if (versions && versions.length > 0) {
      fetchVersion();
    }
  }, [activeVersionIndex, consumerApi, historyMode, provider, versions]);

  useEffect(() => {
    consumerApi.emit(DIFF_MODE_EVENT, diffMode);
  }, [diffMode, consumerApi]);

  return { consumerApi, provider, diffMode, activeVersionIndex };
}



// WEBPACK FOOTER //
// ./app/javascript/client/hooks/useTextEditor.js